<template>
  <!-- the Platforma's own Telegram bot: requests of clients, payment reminders and the weekly report come there at once -->
  <div v-if="state && state.enabled" class="tg-bot" :class="{ 'tg-bot--on': state.connected }">
    <div class="tg-bot__text">
      <div class="tg-bot__title">Telegram-бот Платформи</div>
      <div v-if="state.connected">Бот підключено: заявки клієнтів, нагадування і щотижневий звіт приходять у Telegram.</div>
      <div v-else>Підключіть бота, щоб заявки клієнтів і нагадування про оплату приходили в Telegram одразу.</div>
    </div>
    <div class="tg-bot__actions">
      <a v-if="!state.connected && link" :href="link" target="_blank" rel="noopener" class="tg-bot__btn" @click="waitForLink">Підключити бота</a>
      <button v-if="state.connected" type="button" class="tg-bot__off" :disabled="busy" @click="unlink">Відключити</button>
    </div>
  </div>
</template>

<script>
import ApiClient from "@/libs/http-client";

export default {
  name: "TelegramBotCard",
  data() {
    return {
      state: null,
      link: "",
      busy: false,
      timer: null,
    };
  },
  mounted() {
    this.load();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    load() {
      ApiClient.get("api/psychologists/me/telegram").then((response) => {
        if (!response) return;
        this.state = response.data.data;
        if (this.state.enabled && !this.state.connected) this.newLink();
      });
    },
    // a fresh one-time link: the bot ties itself to this profile by it
    newLink() {
      ApiClient.post("api/psychologists/me/telegram/link").then((response) => {
        if (response) this.link = response.data.data.link;
      });
    },
    // the psychologist presses Start in Telegram: the card turns "connected" by itself
    waitForLink() {
      clearInterval(this.timer);
      let tries = 0;
      this.timer = setInterval(() => {
        tries++;
        ApiClient.get("api/psychologists/me/telegram").then((response) => {
          if (!response) return;
          if (response.data.data.connected || tries > 60) {
            clearInterval(this.timer);
            this.state = response.data.data;
          }
        });
      }, 3000);
    },
    unlink() {
      this.busy = true;
      ApiClient.delete("api/psychologists/me/telegram")
        .then((response) => {
          if (!response) return;
          this.state = response.data.data;
          this.newLink();
        })
        .finally(() => {
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tg-bot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px 24px;
  border: 1px solid #d9e4eb;
  border-radius: 10px;
  background: #fff;
  color: #575756;
  font-size: 15px;
  line-height: 1.45;
}
.tg-bot--on {
  border-left: 4px solid #00a3b7;
}
.tg-bot__text {
  flex: 1 1 320px;
}
.tg-bot__title {
  margin-bottom: 4px;
  color: #00a3b7;
  font-size: 17px;
  font-weight: 500;
}
.tg-bot__btn {
  display: inline-block;
  padding: 10px 22px;
  border-radius: 8px;
  background: #00a3b7;
  color: #fff !important;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}
.tg-bot__off {
  padding: 8px 16px;
  border: 1px solid #d9e4eb;
  border-radius: 8px;
  color: #575756;
  font-size: 14px;
}
</style>
